export const getMentionFormat = (id, value) => {
    return `<span class="mention" data-denotation-char="@" data-id=${id} data-value=${value}><span contenteditable="false">${`@${value}`}</span></span>`
}
